module.exports = {
  familyName: '-apple-system',
  category: 'sans-serif',
  capHeight: 1443,
  ascent: 1950,
  descent: -420,
  lineGap: 0,
  unitsPerEm: 2048,
  xHeight: 1040,
  xWidthAvg: 842
};
